export default __webpack_public_path__ + "static/media/research.89990b40.png";